import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=d852ccc6&scoped=true&"
import script from "./GoToTop.vue?vue&type=script&lang=js&"
export * from "./GoToTop.vue?vue&type=script&lang=js&"
import style0 from "./GoToTop.vue?vue&type=style&index=0&id=d852ccc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d852ccc6",
  null
  
)

export default component.exports